import SettlementInquiry from './settlement-inquiry.vue'
export default SettlementInquiry
